import { ComponentPropsWithoutRef } from 'react'

import Logo from '@/common/Logo'
import Navbar from '@/common/Navbar'
import { config } from '@/config'
import { IconNames } from '@/enums'
import { cn } from '@/theme/utils'
import { UiButtonGradient } from '@/ui/UiButtonGradient'
import UiIcon from '@/ui/UiIcon'

export default function MainLayout({
  className,
  children,
  ...rest
}: ComponentPropsWithoutRef<'div'>) {
  return (
    <div
      {...rest}
      className={cn(
        'flex size-full flex-col',
        'bg-background bg-[url("/images/bg-home.png")] bg-cover bg-blend-normal',
        className,
      )}
    >
      <div className='flex flex-1 flex-col overflow-hidden'>
        <div className='order-2 md:order-1'>
          <Navbar />
        </div>
        <div className='order-1 flex flex-1 flex-col overflow-x-hidden overflow-y-auto pt-5 md:order-2 md:pt-0'>
          <div className='flex flex-1 flex-col gap-4'>
            <div className='flex flex-1'>{children}</div>
            <div className='order-3 flex flex-col items-center pb-8'>
              <Logo />
              {(config.DISCORD_LINK || config.X_LINK) && (
                <div className='mt-7 flex items-center justify-center gap-2'>
                  {config.DISCORD_LINK && (
                    <a href={config.DISCORD_LINK} target='_blank'>
                      <UiButtonGradient
                        asChild
                        variant='secondary'
                        size='icon'
                        radius='default'
                      >
                        <UiIcon name={IconNames.Discord} className='size-5' />
                      </UiButtonGradient>
                    </a>
                  )}

                  {config.X_LINK && (
                    <a href={config.X_LINK} target='_blank'>
                      <UiButtonGradient
                        variant='secondary'
                        size='icon'
                        radius='default'
                      >
                        <UiIcon name={IconNames.X} className='size-5' />
                      </UiButtonGradient>
                    </a>
                  )}
                </div>
              )}
              <span className='typography-m3-body-medium text-muted-foreground mt-5'>
                All rights reserved BitSwapp
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
